import { render } from "./MenuSiConfiguration.vue?vue&type=template&id=718ce729&scoped=true"
import script from "./MenuSiConfiguration.vue?vue&type=script&lang=js"
export * from "./MenuSiConfiguration.vue?vue&type=script&lang=js"

import "./MenuSiConfiguration.vue?vue&type=style&index=0&id=718ce729&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718ce729"]])

export default __exports__